import "./Transfers.css";
import React from "react";
import formatDate from "../../utils/formatDate";
import { useTranslation } from "react-i18next";

const TransferList = ({ orders }) => {
  const {t} = useTranslation();
  return (
    <div className="transfer-container">
      {orders.map((item) => (
        <div key={item.id} className="transfer-item">
          <div className="left">
            <img
              className="avatar"
              size="large"
              src={item.product.image_mobile}
              alt="thumb"
            />
            <div>
              {item.state === "error" ? (
                <h4>Error</h4>
              ) : (
                <h4>{item.ttype === "TD" ? "Stop Game" : "Start Game"}</h4>
              )}
              <p>
                {formatDate(item.created_at).formattedDate}{" "}
                {formatDate(item.created_at).time}
              </p>
            </div>
          </div>
          <div className="right">
            <h5>{item.product.credit_type === "CA" ? t("Cash") : t("Chips")}</h5>
            <p>
              <span className={`${item.amount > 0 ? "green" : "red"}`}>
                {item.amount}
              </span>
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TransferList;
